import React, { useEffect, useState } from 'react'
import Header from '../components/Header'

const Dashboard = () => {
      const [tasks,setTask]=useState([])
     
    useEffect(()=>{
  const data = localStorage.getItem("user")
  if(data){
    setTask([JSON.parse(data)])
  }
},[])
  return (
    <div>
        <Header/>
        <h1>foydalanuvchilar listi</h1>
        {tasks.map((a,index)=>(

            <div className="card" key={index}>
            <h1>ism:{a.name}</h1>
            <h2>email:{a.email}</h2>
            <p>paroli:{a.password}</p>
            </div>
        ))}
    </div>
  )
}

export default Dashboard